import { Box, CssBaseline, Button, Container, Grid, TextField } from "@mui/material"
import NavAppBar from "../components/NavAppBar"
import { useAuth } from "../context/AuthProvider"
import { useState } from "react"
import dataService from '../services/Data'
import CustomDialog from "../components/CustomDialog"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CancelIcon from '@mui/icons-material/Cancel';

export const ConsultaSituacion = () => {
    const { user } = useAuth()
    const [cuit, setCuit] = useState(null)
    const [msjError, setMostrarMsjError] = useState(false)
    const [rdoSituacion, setMostrarRdoSituacion] = useState(null)

    dataService.setToken(user.data.token)

    if (dataService.isTokenExpired(user.data.token)) {
        return window.location.href = '/logout'
    }

    const handleConsultar = async (cuit) => {
        if (!cuit || cuit.length !== 11) {
            setMostrarMsjError("Ingresa un CUIT válido de 11 dígitos");
            return;
        }

        try {
            // Llamamos y esperamos los datos
            const data = await dataService.consultarSituacion(cuit);
            // Validaciones básicas
            if (data.status !== 200 || !data.results?.periodos?.length) {
                setMostrarRdoSituacion({
                    resultado: 'Error',
                    mensaje: 'Respuesta inválida de la API del BCRA',
                    datosCrudos: data
                });
                return;
            }

            const periodoMasReciente = data.results.periodos[0];
            const entidades = periodoMasReciente.entidades || [];

            if (entidades.length === 0) {
                setMostrarRdoSituacion({
                    resultado: 'Evaluar',
                    mensaje: 'No hay deudas registradas en ninguna entidad',
                    nombre: data.results.denominacion || 'Desconocido',
                    entidades: []
                });
                return;
            }

            // Evaluamos situaciones
            let hasSituacion2 = false;
            let hasSituacion3OrMore = false;
            let entidadesConProblema = [];

            entidades.forEach(ent => {
                const sit = ent.situacion;
                if (sit >= 3) {
                    hasSituacion3OrMore = true;
                    entidadesConProblema.push(ent);
                } else if (sit === 2) {
                    hasSituacion2 = true;
                    entidadesConProblema.push(ent);
                }
            });

            let resultado;
            let mensaje;

            if (hasSituacion3OrMore) {
                resultado = 'Rechazar';
                mensaje = 'Detectada situación 3 o superior en al menos una entidad';
            } else if (hasSituacion2) {
                resultado = 'Evaluar';
                mensaje = 'Situación 2 en una o más entidades';
            } else {
                resultado = 'Aprobar';
                mensaje = 'Todas las entidades en situación 1 (Normal)';
            }


            // Guardamos todo en el estado
            setMostrarRdoSituacion({
                resultado,
                mensaje,
                nombre: data.results.denominacion || 'Sin nombre',
                identificacion: data.results.identificacion,
                periodo: periodoMasReciente.periodo,
                entidades,
                entidadesConProblema
            });
        } catch (error) {
            setMostrarRdoSituacion({
                resultado: 'Error',
                mensaje: 'Error de conexión o CUIT no encontrado',
            });
        }
    }

    const handleCuit = (event) => {
        const inputValue = event.target.value;
        const formattedValue = inputValue.replace(/\D/g, '').slice(0, 11);
        setCuit(formattedValue);
        if (inputValue.length == 11) {
            const rta = validarCUIT(inputValue)
            if (!rta) {
                setMostrarMsjError("CUIT inválido.")
            }
        }
        else if (rdoSituacion) {
            setMostrarRdoSituacion(null)
        }
    };

    const validarCUIT = (cuit) => {
        cuit = cuit.replace(/[^0-9]/g, ''); // Elimina no dígitos
        if (cuit.length !== 11) return false; // Debe tener 11 dígitos

        var acumulado = 0;
        var digitos = cuit.split("");
        var digito = digitos.pop();

        for (var i = 0; i < digitos.length; i++) {
            acumulado += digitos[9 - i] * (2 + (i % 6));
        }

        var verif = 11 - (acumulado % 11);
        if (verif == 11) {
            verif = 0;
        } else if (verif == 10) {
            verif = 9;
        }

        return digito == verif;
    }

    return (
        <>
            {!msjError ? "" : <CustomDialog message={msjError} btnText="OK" title="Aviso" state={setMostrarMsjError} open={msjError} />}
            <CssBaseline />
            <NavAppBar />
            <Container>
                <Box
                    sx={{
                        maxWidth: 450,
                        mx: 'auto',              // Esto centra horizontalmente
                        mt: 4,                   // opcional: margen superior para separar del NavAppBar
                    }}
                >
                    <Box display="flex" justifyContent="center" margin="dense">
                        <h2>Consulta Situación Crediticia</h2>
                    </Box>
                    <Box>
                        <TextField fullWidth display="flex" justifyContent="center" margin="dense"
                            label="CUIT"
                            value={cuit}
                            onChange={handleCuit}
                            inputProps={{
                                maxLength: 11, // Enforces max length in the HTML input element
                                inputMode: 'numeric', // Suggests a numeric keyboard on mobile
                                pattern: "[0-9]*" // Basic HTML5 validation pattern
                            }}
                        />
                        <Grid display="flex" justifyContent="center" margin="dense">
                            <Box margin="dense" >
                                <Button size="medium" onClick={() => handleConsultar(cuit)} margin="dense" type="submit" variant="outlined">CONSULTAR</Button>
                            </Box>
                        </Grid>
                    </Box>
                    {rdoSituacion && (
                        <Box
                            sx={{
                                mt: 4,
                                p: 3,
                                borderRadius: 2,
                                boxShadow: 3,
                                textAlign: 'center',
                                backgroundColor:
                                    rdoSituacion.resultado === 'Aprobar' ? '#e8f5e9' :
                                        rdoSituacion.resultado === 'Evaluar' ? '#fff3e0' :
                                            rdoSituacion.resultado === 'Rechazar' ? '#ffebee' :
                                                '#f5f5f5',
                                border:
                                    rdoSituacion.resultado === 'Aprobar' ? '2px solid #4caf50' :
                                        rdoSituacion.resultado === 'Evaluar' ? '2px solid #ff9800' :
                                            rdoSituacion.resultado === 'Rechazar' ? '2px solid #f44336' :
                                                '2px solid #999',
                            }}
                        >
                            {rdoSituacion.resultado === 'Aprobar' && (
                                <>
                                    <h3 style={{ color: '#2e7d32' }}>¡APROBADO!</h3>
                                    <p><strong>{rdoSituacion.nombre}</strong></p>
                                    <p>Todas las entidades en situación 1.<br />Podemos avanzar sin problemas.</p>
                                    <CheckCircleIcon sx={{ fontSize: '5rem', color: '#2e7d32' }} />
                                </>
                            )}

                            {rdoSituacion.resultado === 'Evaluar' && (
                                <>
                                    <h3 style={{ color: '#ef6c00' }}>EVALUAR MANUALMENTE</h3>
                                    <p><strong>{rdoSituacion.nombre}</strong></p>
                                    <p>{rdoSituacion.mensaje}<br />Revisar caso por caso.</p>
                                    <ErrorOutlineIcon sx={{ fontSize: '5.5rem', color: '#ef6c00' }} />
                                </>
                            )}

                            {rdoSituacion.resultado === 'Rechazar' && (
                                <>
                                    <h3 style={{ color: '#c62828' }}>RECHAZADO</h3>
                                    <p><strong>{rdoSituacion.nombre}</strong></p>
                                    <p>{rdoSituacion.mensaje}<br />No se puede aprobar.</p>
                                    <CancelIcon sx={{ fontSize: '5.5rem', color: '#c62828' }} />
                                </>
                            )}

                            {rdoSituacion.resultado === 'Error' && (
                                <>
                                    <h3 style={{ color: '#666' }}>Error</h3>
                                    <p>{rdoSituacion.mensaje}</p>
                                </>
                            )}
                        </Box>
                    )}
                </Box>
            </Container>
        </>
    )
}